var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardCrashanalysisIssuelistUnfoldErrorstackMark = function SvgNewcsDashboardCrashanalysisIssuelistUnfoldErrorstackMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 11
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_dashboard_crashanalysis_issuelist_unfold_errorstack_mark_svg__clip-path)",
    transform: "translate(-617 -137)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fb835e",
    d: "m623 137 1.53 4.051 4.47.149-3.524 2.656 1.232 4.144-3.708-2.41-3.708 2.41 1.232-4.144L617 141.2l4.47-.151Z",
    "data-name": "\\u591A\\u8FB9\\u5F62 3"
  }))));
};
export default SvgNewcsDashboardCrashanalysisIssuelistUnfoldErrorstackMark;